import { useState } from 'react';

import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';
import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

export const useIsWaitingUserPlay = () => {
    const instance = usePlayerInstance();
    const [isWaitingUserPlay, setIsWaitingUserPlay] = useState<boolean>(
        () => !!instance && instance.isWaitingUserPlay
    );

    useInstanceEffect((instance) => instance.onWaitingUserPlayChange(setIsWaitingUserPlay));

    return isWaitingUserPlay;
};
